<div [appStoryblok]="_editable()">
  <div [style.padding-bottom]="format_ratio() || '56.25%'" class="videoWrapper"></div>
</div>
